export class AppointmentDetailDataModel {
  AppointmentDetailId: string;
  AppointmentId: string;
  DetailParameterName: string;
  DetailParameterValue: string;
}
